import { ADMISSION_CARE_TEAM_LIMIT, type AdmissionCareTeamEntry, type AdmissionSupportRole } from '@his/shared';

export interface DraftCareMember {
  key: string;
  userId: string;
  role: AdmissionSupportRole;
}

export const ADMIT_CARE_TEAM_ROWS = ADMISSION_CARE_TEAM_LIMIT - 1;

export function admitCareTeamPayload(rows: readonly DraftCareMember[], primaryId: string): AdmissionCareTeamEntry[] {
  const seen = new Set<string>(primaryId ? [primaryId] : []);
  const team: AdmissionCareTeamEntry[] = [];
  for (const row of rows) {
    if (!row.userId || seen.has(row.userId)) continue;
    seen.add(row.userId);
    team.push({ userId: row.userId, role: row.role });
  }
  return team;
}

export function choosableDoctors<T extends { id: string }>(doctors: readonly T[], rows: readonly DraftCareMember[], primaryId: string, ownUserId: string): T[] {
  const taken = new Set(rows.filter((row) => row.userId && row.userId !== ownUserId).map((row) => row.userId));
  if (primaryId) taken.add(primaryId);
  return doctors.filter((doctor) => !taken.has(doctor.id));
}
